import { BaseContract } from '../common/base.contract';
import { Contract, JsonRpcProvider } from 'ethers';
import { toNumber } from '../common/base-cdk-contract';
import StakingFactoryFacetAbi from '../../abi/Facets/StakingFactoryFacet.json';
import { StakingData } from '../../model/staking.model';
import { mapToStakingInfo } from '../../mappers/staking.mapper';
import { log } from 'console';

export type StakingInfo = {
    stakingId: string;
    stakingDetails: StakingData;
}

export class StakingFactoryFacet extends BaseContract {
    constructor(address: string, provider: JsonRpcProvider) {
        super(new Contract(address, StakingFactoryFacetAbi.abi, provider));
    }

    // Méthodes de lecture
    checkStakingExists = async (stakingId: string): Promise<boolean> => {
        return await this.contract.checkStakingExists(stakingId);
    }

    getAllStakingDetails = async (): Promise<StakingInfo[]> => {
        try {
            const signedContract = await this._getSignedContract();
            const stakings = await signedContract.getAllStakingDetails();
            return stakings.map((data: any) => mapToStakingInfo(data));
        } catch (error: any) {
            if (error.code === 'BAD_DATA' && error.value === '0x') {
                console.log('Contract returned empty data - no staking rounds exist');
                return [];
            }
            
            console.error('Error in getAllStakingDetails:', error);
            throw error;
        }
    }

    // Méthodes d'écriture
    doCreateStaking = async (
        newStakingId: string,
        cliffPeriod: number,
        vestingPeriod: number,
        stakingRewardPercentage: number
    ) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.doCreateStaking(
            newStakingId,
            cliffPeriod,
            vestingPeriod,
            stakingRewardPercentage
        );
        await tx.wait();
    }

    doSendBackStakedTokensAfterStakingEnds = async () => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.doSendBackStakedTokensAfterStakingEnds();
        await tx.wait();
    }
} 
